<style lang="scss">
#paging {
  .total {
    span {
      color: #808080;
    }
  }
  a,
  svg {
    color: #173d8f;
    cursor: pointer;
  }
  svg {
    margin-left: 3px;
  }
  .col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .selectAll {
    justify-content: start;
  }
  .navigation {
    a {
      font-weight: 500;
      display: inline-block;
      padding: 2px 6px;
    }
  }
}
</style>
<template>
  <v-row id="paging"  v-if="!mobiTablet">
    <v-col class="selectAll" md="5">
      <slot name="selectAll" />
    </v-col>
    <v-col md="7" class="d-flex justify-end align-center">
      <div class="total mr-5">
        <slot name="totalItems"></slot>
      </div>
      <div>
        <span class="mr-1">
          <v-icon light right size="16" color="#003e94"  @click="goFirst">first_page</v-icon>
          <v-icon light right size="16" color="#003e94"  @click="prev">chevron_left</v-icon>
        </span>
        <span md="1" class="navigation">
          <span v-if="!displayPage.includes(1)">...</span>
          <a
            :class="{ active: paging.offset / paging.limit == i - 1 }"
            v-for="i in displayPage"
            :key="i"
            @click="navigate(i)"
          >{{ i }}</a>
          <span v-if="displayPage[displayPage.length - 1] != totalPage">...</span>
        </span>
        <span>
          <v-icon light right size="16" color="#003e94"  @click="next">chevron_right</v-icon>
          <v-icon light right size="16" color="#003e94"  @click="goLast">last_page</v-icon>
        </span>
      </div>
    </v-col>
  </v-row>
   <v-row id="paging"  v-else>
    <v-col class="d-flex justify-end align-center">
      <div class="total mr-5">
        <slot name="totalItems"></slot>
      </div>
      <div>
        <span class="mr-1">
          <v-icon light right size="16" color="#003e94"  @click="goFirst">first_page</v-icon>
          <v-icon light right size="16" color="#003e94"  @click="prev">chevron_left</v-icon>
        </span>
        <span md="1" class="navigation">
          <span v-if="!displayPage.includes(1)">...</span>
          <a
            :class="{ active: paging.offset / paging.limit == i - 1 }"
            v-for="i in displayPage"
            :key="i"
            @click="navigate(i)"
          >{{ i }}</a>
          <span v-if="displayPage[displayPage.length - 1] != totalPage">...</span>
        </span>
        <span>
          <v-icon light right size="16" color="#003e94"  @click="next">chevron_right</v-icon>
          <v-icon light right size="16" color="#003e94"  @click="goLast">last_page</v-icon>
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    paging: Object,
    changePage: Function
  },
  data() {
    return {
      displayPage: [],
      currentPage: 1
    };
  },
  created() {
    this.configPageNavagation();
  },
  watch: {
    paging: {
      handler(value) {
        document.documentElement.scrollTop = 0;
        this.currentPage = this.paging.offset / this.paging.limit + 1;
        if (this.totalPage < this.currentPage) {
          this.prev();
        }
        this.configPageNavagation();
      },
      deep: true
    },
    totalPage(value) {
      if (value < this.displayPage.length) {
        let diffirentCount = this.displayPage.length - value;
        this.displayPage.splice(value, diffirentCount);
      }
    }
  },
  computed: {
    totalPage() {
      return this.paging.total % this.paging.limit > 0
        ? parseInt(this.paging.total / this.paging.limit) + 1
        : this.paging.total / this.paging.limit;
    }
  },
  methods: {
    configPageNavagation() {
      this.currentPage = this.paging.offset / this.paging.limit + 1;
      this.displayPage = [];
      if (this.currentPage >= this.totalPage - 1) {
        for (let i = this.currentPage - 2; i <= this.currentPage + 1; i++) {
          if (i > 0 && i <= this.totalPage) {
            this.displayPage.push(i);
          }
        }
        if (this.displayPage.length > 3) {
          this.displayPage.splice(0, 1);
        }
        if (
          (this.displayPage.length == 3 || this.totalPage <= 3) &&
          this.currentPage != 1
        ) {
          return true;
        }
      }
      this.displayPage = [];
      for (
        let i = this.currentPage;
        i <= (this.totalPage < 3 ? this.totalPage : this.currentPage + 2);
        i++
      ) {
        this.displayPage.push(i);
        if (i >= this.totalPage) break;
      }
      if (!this.displayPage.length) {
        this.displayPage.push(1);
      }
    },
    prev() {
      if (this.paging.offset == 0) {
        return false;
      }
      this.paging.offset -= this.paging.limit;
      this.configPageNavagation();
      this.$emit("changePage", this.paging);
    },
    next() {
      if (this.paging.offset == (this.totalPage - 1) * this.paging.limit) {
        return false;
      }
      this.paging.offset += this.paging.limit;
      this.configPageNavagation();
      this.$emit("changePage", this.paging);
    },
    goFirst() {
      if (this.paging.offset == 0) {
        return false;
      }
      this.paging.offset = 0;
      this.configPageNavagation();
      this.$emit("changePage", this.paging);
    },
    goLast() {
      if (this.paging.offset == (this.totalPage - 1) * this.paging.limit) {
        return false;
      }
      this.paging.offset = (this.totalPage - 1) * this.paging.limit;
      this.configPageNavagation();
      this.$emit("changePage", this.paging);
    },
    navigate(page) {
      this.paging.offset = (page - 1) * this.paging.limit;
      this.configPageNavagation();
      this.$emit("changePage", this.paging);
    }
  }
};
</script>
